import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Flame, ArrowRight } from "lucide-react";
import api from "../lib/api";

const GOLD = "#D9B36A";

export const LaunchCountdown = () => {
  const { t } = useTranslation();
  const nav = useNavigate();
  const [launch, setLaunch] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    setLaunch(null);
  }, []);
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(id);
  }, []);

  if (!launch?.active || !launch?.ends_at) return null;
  const left = new Date(launch.ends_at) - now;
  if (left <= 0) return null;
  const days = Math.max(1, Math.ceil(left / 86400000));

  return (
    <button
      data-testid="launch-countdown-banner"
      onClick={() => nav("/paywall")}
      className="w-full flex items-center justify-between gap-3 rounded-2xl px-4 py-3 mb-4 transition-all hover:scale-[1.01]"
      style={{
        background: "linear-gradient(100deg, rgba(217,179,106,0.16), rgba(217,179,106,0.04))",
        border: `1px solid ${GOLD}`,
        boxShadow: "0 0 24px rgba(217,179,106,0.14)",
      }}
    >
      <span className="flex items-center gap-2.5 min-w-0">
        <Flame size={18} style={{ color: GOLD }} className="shrink-0" />
        <span className="text-left leading-tight">
          <span className="block text-[13px] font-black tracking-wide" style={{ color: GOLD }}>
            {t("launch.title", { defaultValue: "Tarifs de lancement HitMax" })}
          </span>
          <span className="block text-[12px] text-white/70">
            {t("launch.subtitle", { days, defaultValue: `Plus que ${days} jour${days > 1 ? "s" : ""} à -50%` })}
          </span>
        </span>
      </span>
      <ArrowRight size={18} style={{ color: GOLD }} className="shrink-0" />
    </button>
  );
};

export default LaunchCountdown;
